import { render, staticRenderFns } from "./expreimburs-adjust.vue?vue&type=template&id=a050d652"
import script from "./expreimburs-adjust.vue?vue&type=script&lang=js"
export * from "./expreimburs-adjust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports